<template>
    <div
        class="reply-message"
        @click="forwardMessage"
        v-tippy="{ followCursor: true, placement: 'top-center' }"
        :content="$t('message.jumpToMessage')"
    >
        <div class="reply-message-text">
            {{ $t("auto.replyingTo") }} <span>{{ visitorName }}</span>
        </div>
        <div class="reply-message-remove" @click.stop="removeReply">
            <div class="material-icons">cancel</div>
        </div>
    </div>

</template>

<script>
import { log2 } from "../../../../../utils/log2";
import { mapActions } from "vuex";

const log = log2("ReplyMessage");
export default {
    name: "ReplyMessage",
    props: {
        message: {
            type: Object,
            default: () => ({}),
        },
        visitorName: {
            type: String,
            default: "",
        },
    },
    methods: {
        ...mapActions({
            unpinReplyToMessage: "chat/unpinReplyToMessage",
        }),
        forwardMessage() {
            const message = document.querySelector(`#sc-message_${this.message.raw.uniqMessageId}`);
            if (message) {
                message.scrollIntoView({ block: "center" });
                message.classList.add("focused-element");
                setTimeout(() => {
                    message.classList.remove("focused-element");
                }, 1000);
            }
        },
        removeReply(e) {
            const conversationId = this.$_.get(
                this.message,
                "raw.conversation",
                this.$_.get(this.message, "raw.conversationId", null)
            );
            if (conversationId) this.unpinReplyToMessage(conversationId);
            e.stopPropagation();
        },
    },
};
</script>
<style>
@keyframes focused-animation {
    0% {
        transform: translateX(0);
    }
    50% {
        transform: translateX(20px);
    }
    100% {
        transform: translateX(0);
    }
}

.focused-element {
    animation: focused-animation 1s ease-in-out forwards;
}
</style>
<style lang="scss" scoped>
.reply-message {
    cursor: pointer;
    width: 100%;
    background: #22272d;
    padding: 6px 10px;
    color: white;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 4px;
    user-select: none;

    &-text {
        span {
            font-weight: bold;
        }
    }
    &-remove {
        width: 15px;
        height: 15px;
        display: flex;
        align-items: center;
        justify-content: center;
        .material-icons {
            color: white;
            font-size: 20px;
        }
    }
}
</style>
